import React, { useState, useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Portfolio } from './components/Portfolio';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { translations } from './mock';

function App() {
  const [currentLang, setCurrentLang] = useState('pl');
  const [isDark, setIsDark] = useState(true);
  const t = translations[currentLang];

  useEffect(() => {
  const savedTheme = localStorage.getItem('theme');

  if (savedTheme) {
    setIsDark(savedTheme === 'dark');
  } 
  
  else {
    const systemPrefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;

    setIsDark(systemPrefersDark);
  }
  }, []);


  return (
    <div className={`App ${isDark ? 'dark-theme' : 'light-theme'}`}>
      <Navbar 
        currentLang={currentLang} 
        setCurrentLang={setCurrentLang} 
        translations={t}
        isDark={isDark}
        setIsDark={setIsDark}
      />
      <Hero translations={t} isDark={isDark} />
      <Services translations={t} isDark={isDark} />
      <About translations={t} isDark={isDark} />
      <Portfolio translations={t} isDark={isDark} />
      <Contact translations={t} isDark={isDark} />
      <Footer translations={t} isDark={isDark} />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;